import { render } from "./TaskSettingsAttachments.vue?vue&type=template&id=3ad0dfd2"
import script from "./TaskSettingsAttachments.vue?vue&type=script&lang=js"
export * from "./TaskSettingsAttachments.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./TaskSettingsAttachments.vue?vue&type=style&index=0&id=3ad0dfd2&module=true&lang=less"
cssModules["$style"] = style0

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__